import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Employee Category

  SaveEmployeeCategory(data): Observable<any> {
    let param = 'objEmployeeCategory=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/SaveEmployeeCategory?'
      + encodeURI(param), { headers: reqHeader });
  }

  GetAllEmployeeCategory(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/GetAllEmployeeCategory', { headers: reqHeader });
  }

  EmployeeCategoryMarkActive(data): Observable<any> {
    let param = 'objEmployeeCategory=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/EmployeeCategoryMarkActive?'
      + encodeURI(param), { headers: reqHeader });
  }

  // UPLOAD STAFF

  UploadStaff(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objStaff", data);
    formData.append("StaffData", file);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/UploadStaff', formData);
  }

  UpdateStaff(data): Observable<any> {

    let formData = new FormData();
    formData.append("staff", data);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/UpdateStaff', formData);
  }

  // Staff Profile

  SaveStaffDetails(StaffDetails, SalaryComponent, DocsList, StaffPhoto, StaffDependent, StaffAction): Observable<any> {

    let formData = new FormData();

    for (var i = 0; i < DocsList.length; i++) {

      formData.append("docsFile" + i, DocsList[i].FileUpload);
    }
    formData.append("StaffDetails", StaffDetails);
    formData.append("SalaryComponent", JSON.stringify(SalaryComponent));
    formData.append("StaffDependent", StaffDependent);
    formData.append("StaffPhoto", StaffPhoto);
    formData.append("DocsList", JSON.stringify(DocsList));
    formData.append("StaffAction", StaffAction);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/SaveStaffDetails', formData);
  }

  StaffMarkActive(data): Observable<any> {
    let param = 'StaffDetail=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/StaffMarkActive?'
      + encodeURI(param), { headers: reqHeader });
  }

  GetStaffDependentDetails(data): Observable<any> {
    let param = 'StaffID=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/GetStaffDependentDetails?'
      + encodeURI(param), { headers: reqHeader });
  }

  GetStaffChildDetails(data): Observable<any> {
    let param = 'StaffID=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/GetStaffChildDetails?'
      + encodeURI(param), { headers: reqHeader });
  }

  RemoveStaffChild(data): Observable<any> {
    let param = 'StaffDetail=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/RemoveStaffChild?'
      + encodeURI(param), { headers: reqHeader });
  }

  GetStaffDocumentPhoto(data): Observable<any> {
    let param = 'StaffID=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/GetStaffDocumentPhoto?'
      + encodeURI(param), { headers: reqHeader });
  }

  GetDownloadStaff(data): Observable<any> {
    let param = 'Staffdetails=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/GetDownloadStaff?'
      + encodeURI(param), { headers: reqHeader });
  }

  SearchAllstaff(data): Observable<any> {
    let param = 'Staffdetails=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffProfile/SearchAllstaff?'
      + encodeURI(param), { headers: reqHeader });
  }

}
